import { ReactComponent as CloseIcon } from "assets/icons/tick-circle-red.svg";
import { Layout } from "components/Layout";
import { Link } from "react-router-dom";
import { generalLogicService } from "services/generalLogicService";
import { useSnapshot } from "valtio";

export const ErrorPage = () => {
  const { error } = useSnapshot(generalLogicService);

  const text = error
    ? `${error.status}${error.message ? `: ${error.message}` : ""}`
    : "Error 404: Page doesn’t exist";

  return (
    <Layout hasHeader={false} mainClassName="verification">
      <section className="verification-container">
        <div className="verification-wrapper">
          <CloseIcon />
          <h1 className="verification-title__header title error-title">
            {text}
          </h1>
          <Link
            className="verification-title__link g-underline"
            onClick={() => generalLogicService.clearError()}
            to="/"
          >
            Go to home page
          </Link>
        </div>
      </section>
    </Layout>
  );
};
